module.exports = __webpack_public_path__ + "static/media/vnsgu_logo.e80a5ddf.png";